import React from "react";
import { Alert, Box, Chip, LinearProgress, Typography } from "@mui/material";
import SectionHeader from "../components/common/SectionHeader";
import CommonDataGrid from "../components/grid/CommonDataGrid";
import { marketDataApi } from "../services/marketDataApi";

const MarketsPage = () => {
  const { data: assets = [], isLoading, error } = marketDataApi.endpoints.getAllMarketAssets.useQuery();

  const columns = React.useMemo(
    () => [
      { field: "symbol", headerName: "Symbol", valueGetter: (row) => row.symbol },
      { field: "name", headerName: "Name", valueGetter: (row) => row.name },
      {
        field: "assetType",
        headerName: "Type",
        renderCell: (row) => (
          <Chip
            size="small"
            color={row.assetType === 0 || row.assetType === "Crypto" ? "secondary" : "primary"}
            label={row.assetType === 0 || row.assetType === "Crypto" ? "Crypto" : "Stock"}
          />
        ),
      },
      { field: "exchangeSymbol", headerName: "Exchange", valueGetter: (row) => row.exchangeSymbol || "—" },
      { field: "currentPrice", headerName: "Price", align: "right", valueGetter: (row) => Number(row.currentPrice || 0) },
      { field: "marketCap", headerName: "Market Cap", align: "right", valueGetter: (row) => Number(row.marketCap || 0) },
      { field: "totalVolume", headerName: "Volume", align: "right", valueGetter: (row) => Number(row.totalVolume || 0) },
    ],
    []
  );

  if (isLoading) return <LinearProgress />;
  if (error) return <Alert severity="error">Failed to load markets.</Alert>;

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <SectionHeader variant="h4" component="h1" gutterBottom sx={{ pb: 0.75 }}>
        Markets
      </SectionHeader>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Browse all tracked stocks and crypto market assets.
      </Typography>
      <CommonDataGrid
        rows={assets}
        columns={columns}
        getRowId={(row) => row.marketAssetId}
        initialSortField="marketCap"
        initialSortDirection="desc"
        filterPlaceholder="Filter markets by symbol, name, exchange..."
      />
    </Box>
  );
};

export default MarketsPage;
